import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import userContextSlice from '../../../common/slices/userContextSlice';
import {
  PatchedUserPreferences,
  useApiPortalV1UserPreferencesUpdatePreferencesPartialUpdateMutation,
} from '../../../store/generated/portal/user-preferences';

export type GuidedExperienceState = Record<string, any>;

export const useUpdateGuidedExperienceState = () => {
  const user = useSelector(userContextSlice.selectors.getUser);
  const [updatePreferences, updateResult] =
    useApiPortalV1UserPreferencesUpdatePreferencesPartialUpdateMutation();

  const updateGuidedExperienceState = useCallback(
    async (guidedExperienceState: GuidedExperienceState) => {
      const userId = user?.id;
      if (!userId) {
        throw new Error('Unable to update guided experience state without a valid user ID');
      }

      await updatePreferences({
        id: userId,
        patchedUserPreferences: { guided_experience_state: guidedExperienceState } as PatchedUserPreferences & {
          guided_experience_state: GuidedExperienceState;
        },
      }).unwrap();
    },
    [updatePreferences, user?.id]
  );

  return {
    updateGuidedExperienceState,
    isLoading: updateResult.isLoading,
    isError: updateResult.isError,
    error: updateResult.error,
  };
};
